<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Sunucu Yönetimi</span>
            <div>
              <v-btn color="primary" @click="showAddDialog = true">
                <v-icon left>mdi-plus</v-icon>
                Sunucu Ekle
              </v-btn>
              <v-btn color="secondary" to="/" class="ml-2">
                <v-icon left>mdi-arrow-left</v-icon>
                Dashboard
              </v-btn>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="servers"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:item.is_active="{ item }">
              <v-chip :color="item.is_active ? 'success' : 'error'" small>
                {{ item.is_active ? 'Aktif' : 'Pasif' }}
              </v-chip>
            </template>
            
            <template v-slot:item.last_sync="{ item }">
              {{ item.last_sync ? formatDate(item.last_sync) : 'Henüz senkronize edilmedi' }}
            </template>
            
            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                size="small"
                color="primary"
                @click="syncServer(item.id)"
                :loading="syncingServers.includes(item.id)"
              >
                <v-icon>mdi-sync</v-icon>
              </v-btn>
              <v-btn
                icon
                size="small"
                color="error"
                @click="deleteServer(item.id)"
                class="ml-2"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Add Server Dialog -->
    <v-dialog v-model="showAddDialog" max-width="500px">
      <v-card>
        <v-card-title>Yeni Sunucu Ekle</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-text-field
              v-model="newServer.name"
              label="Sunucu Adı"
              :rules="[v => !!v || 'Sunucu adı gerekli']"
              required
            ></v-text-field>
            <v-text-field
              v-model="newServer.url"
              label="Sunucu URL"
              :rules="[v => !!v || 'URL gerekli', v => isValidUrl(v) || 'Geçerli bir URL girin']"
              placeholder="https://example.com"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showAddDialog = false">İptal</v-btn>
          <v-btn
            color="primary"
            @click="addServer"
            :disabled="!formValid"
            :loading="adding"
          >
            Ekle
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// axios artık $api olarak global olarak mevcut

export default {
  name: 'Servers',
  data() {
    return {
      servers: [],
      loading: false,
      showAddDialog: false,
      formValid: false,
      adding: false,
      syncingServers: [],
      newServer: {
        name: '',
        url: ''
      },
      headers: [
        { title: 'ID', key: 'id', width: '80px' },
        { title: 'Sunucu Adı', key: 'name' },
        { title: 'URL', key: 'url' },
        { title: 'Durum', key: 'is_active', width: '120px' },
        { title: 'Son Senkronizasyon', key: 'last_sync', width: '200px' },
        { title: 'İşlemler', key: 'actions', sortable: false, width: '120px' }
      ]
    }
  },
  mounted() {
    this.loadServers()
  },
  methods: {
    async loadServers() {
      this.loading = true
      try {
        const response = await this.$api.get('/api/servers')
        this.servers = response.data
      } catch (error) {
        console.error('Error loading servers:', error)
      } finally {
        this.loading = false
      }
    },
    async addServer() {
      if (!this.formValid) return
      
      this.adding = true
      try {
        await this.$api.post('/api/servers', this.newServer)
        this.showAddDialog = false
        this.newServer = { name: '', url: '' }
        this.$refs.form.reset()
        await this.loadServers()
      } catch (error) {
        console.error('Error adding server:', error)
        alert('Sunucu eklenirken hata oluştu: ' + (error.response?.data?.error || error.message))
      } finally {
        this.adding = false
      }
    },
    async syncServer(serverId) {
      this.syncingServers.push(serverId)
      try {
        await this.$api.post(`/api/servers/${serverId}/sync`)
        await this.loadServers()
      } catch (error) {
        console.error('Error syncing server:', error)
        alert('Senkronizasyon hatası: ' + (error.response?.data?.error || error.message))
      } finally {
        this.syncingServers = this.syncingServers.filter(id => id !== serverId)
      }
    },
    async deleteServer(serverId) {
      if (!confirm('Bu sunucuyu silmek istediğinizden emin misiniz?')) return
      
      try {
        await this.$api.delete(`/api/servers/${serverId}`)
        await this.loadServers()
      } catch (error) {
        console.error('Error deleting server:', error)
        alert('Sunucu silinirken hata oluştu: ' + (error.response?.data?.error || error.message))
      }
    },
    isValidUrl(url) {
      try {
        new URL(url)
        return true
      } catch {
        return false
      }
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleString('tr-TR')
    }
  }
}
</script>